import { IRoute, Routes } from './route';

// menu
export const RouteMenus: IRoute[] = [
  Routes.HOME,
  Routes.TIN_TUC,
  { ...Routes.TUYEN_DUNG, children: [Routes.TUYEN_DUNG_UNG_VIEN, Routes.TUYEN_DUNG_BAO_CAO] },
  Routes.NHAN_SU,
  { ...Routes.BANG_CONG, children: [Routes.LICH_LAM_VIEC, Routes.BANG_CONG_THANG, Routes.TONG_HOP_CONG] },
  { ...Routes.DON_XIN_NGHI, children: [Routes.DON_XIN_NGHI_PHE_DUYET, Routes.DON_XIN_NGHI_TONG_HOP] },
  Routes.CONG_VIEC,
  { ...Routes.LUONG, children: [Routes.LUONG_TONG_HOP_LUONG, Routes.LUONG_BAC_LUONG, Routes.LUONG_KHUNG_NANG_LUC] },
  {
    ...Routes.CAU_HINH,
    children: [
      Routes.CAU_HINH_PHONG_BAN,
      Routes.CAU_HINH_CHUC_VU,
      Routes.CAU_HINH_VAI_TRO,
      Routes.CAU_HINH_CHE_DO_PHUC_LOI,
      Routes.CAU_HINH_CONG_CU_LAM_VIEC,
      Routes.CAU_HINH_CHAM_CONG,
      Routes.CAU_HINH_LOAI_NGHI_PHEP,
    ],
  },
  { ...Routes.PHAN_QUYEN, children: [Routes.PHAN_QUYEN_NHOM, Routes.PHAN_QUYEN_NHAN_SU] },
];
